var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 233,
    height: 289,
    viewBox: "0 0 233 289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #f9bd36;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    className: "cls-1",
    width: 233,
    height: 289,
    transform: "translate(1047 2026)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25",
    "data-name": "Mask Group 25",
    className: "cls-2",
    transform: "translate(-1047 -2026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    transform: "translate(1047 1941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-3",
    d: "M177.5,0A177.5,177.5,0,1,0,355,177.5,177.5,177.5,0,0,0,177.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-4",
    d: "M177.5,35.5c78.3,0,142,63.7,142,142s-63.7,142-142,142c-36.547,0-70.959-13.565-96.9-38.2-29.082-27.607-45.1-64.47-45.1-103.8,0-78.3,63.7-142,142-142m0-35.5A177.5,177.5,0,0,0,0,177.5c0,50.682,21.241,96.4,56.158,129.547A177.5,177.5,0,1,0,177.5,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/half_circle.674201e982fb37ef40a71eb6184d0127.svg";
export { ForwardRef as ReactComponent };